import Search from "./ui/search";

export default Search;